@if (isLoading) {
  <mwp-placeholder-table [displayButton]="true" />
}
@if (panelWidgetEnrollment) {
  <div class="content-container">
    <div class="content widget-container">
      <iframe [src]="currentUrl | pipeSafeURL" frameborder="0" class="w-100">
        <div>
          <mwp-text-translate text="iframes are not supported by your browser." jsonKey="iFramesNotSupported" />
        </div>
      </iframe>
    </div>
  </div>
}
@if (isNotConfigured) {
  <mwp-wizard-error [errorPanelName]="errorPanelName" />
}